import templateUrl from './reference-map.html';
import clone from 'lodash/clone';

export const referenceMapComponent = {
    bindings: {
        details: '<',
        slugUrl: '@'
    },

    templateUrl,

    controller: class ReferenceMapComponent {
        constructor($state, PlanningResourcesService, toastr) {
            'ngInject';

            this.$state = $state;
            this.planningResourcesService = PlanningResourcesService;
            this.toastr = toastr;
        }

        $onInit() {
            this.details = this.planningResourcesService.getReferenceMapDetailsObject(this.details.data);
            this.pageTitle = "Reference maps";
            this.disableButtons = false;
            this.editorFieldError = false;
        }

        setEditorDetails(editorDetails) {
			this.details = clone(editorDetails);
			this._setEditorFieldError();
		}

        onSubmit() {
            this.disableButtons = true;
            this._setEditorFieldError();

            if(!this.editorFieldError) {
                this.planningResourcesService.updateReferenceMapDetails(this.details)
                    .then(_ => {
                        this.toastr.success('Data updated successfully');
                        this.disableButtons = false;
                    })
                    .catch(err => {
                        this.toastr.error(err);
                        this.disableButtons = false;
                        throw err;
                    });
            }
        }

        onCancel() {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: 'home-banner'
            });
        }

        //****************************************************Private Methods************************************ */

        _setEditorFieldError() {
			this.editorFieldError = this.details.description.trim().length > 0 ? false : true;
		}
    }
};


// WEBPACK FOOTER //
// ./src/app/components/planning-resources/reference-map/reference-map.component.js